/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Modals\ModalReservation\ModalReservation.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Friday September 6th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday September 6th 2024 8:38:34 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler } from 'react';
import MyModal from "Content/Modals/MyModal";
import translator from 'MultiLanguage/TranslationWrapper';
import Styles from "Content/Modals/ModalReservation/ModalReservation.module.css";
import { PricingType } from 'Types/pricing.type';
import { Button } from '@mui/material';

type ModalReservationProps = {
    data: PricingType | undefined,
    nbCar: number,
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string,
    makeReservation: MouseEventHandler<HTMLButtonElement>
};

export default function ModalReservation(props: ModalReservationProps) {

    const myFooter = () => {
        return (
            <div>
                <Button color="error" onClick={props.closeModal}>{translator.decode("dynamic.cancel")}</Button>
                <Button variant="contained" className="ms-3" onClick={props.makeReservation}>{translator.decode("dynamic.confirm")}</Button>
            </div>
        );
    };

    const reservationDetails = [
        {
            title: translator.decode("modal.reservation.type"),
            value: props.data?.Type
        },
        {
            title: translator.decode("modal.reservation.quantity"),
            value: props.nbCar
        },
        {
            title: translator.decode("modal.reservation.price"),
            value: `${props.data?.Amount}${translator.decode("modal.reservation.pricing")}`
        },
        {
            title: translator.decode("modal.reservation.month"),
            value: `${props.data?.Month} ${translator.decode("modal.reservation.monthly")}`
        },
        {
            title: translator.decode("modal.reservation.mileage"),
            value: `${props.data?.Mileage}km`
        }
    ];

    return (
        <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={myFooter()} title={""} className={Styles.modalCtaStyle} themeColor={props.themeColor}>
            <div className={`${Styles.modal}`}>
                <span>{translator.decode("modal.reservation.title")}</span>
                <div className={`${Styles.detailHolder}`}>
                    {
                        reservationDetails.map(x => {return <div className={`${Styles.detail}`}>
                            <span>{x.title}</span>
                            <strong>{x.value}</strong>
                        </div>})
                    }
                </div>
                <p className='m-0'>{translator.decode("modal.warning")}</p>
            </div>
        </MyModal>
    );
};
